import { currencyToNumber } from '@iwoca/orion';
import * as yup from 'yup';

export const schema = yup.object().shape({
    email: yup
        .string()
        .email('Please use a valid email format')
        .required('Email address is required'),
    amount: yup
        .string()
        .required('Loan amount is required')
        .test(
            'minCurrencyAmount',
            'Between £1,000 and £1,000,000',
            (value: string) => {
                const numericValue = currencyToNumber(value, {
                    currencySymbol: true,
                    locale: 'en-GB',
                    minorUnits: false
                });
                if (!numericValue) return false;
                return numericValue >= 1000 && numericValue <= 1000000;
            }
        ),
    loanDuration: yup
        .string()
        .oneOf(
            ['12-months', '24-months', '36-months', '48-months', '60-months'],
            'Please choose a term length'
        )
        .required('Please choose a term length'),
    loanPurpose: yup
        .string()
        .oneOf(
            [
                'stock_purchase',
                'pay_staff',
                'pay_bill',
                'refinancing_debt',
                'growing_business',
                'supporting_cashflow',
                'other',
                'no_specific_need'
            ],
            'Please choose a reason'
        )
        .required(() => 'Please choose a reason')
});
